import { useState } from "react";
import ChartTooltip from "./ChartTooltip";

/** Vertical bar chart with hover tooltips. */
export default function BarChart({
  values = [],
  labels = [],
  height = 180,
  accent = "var(--chart-line)",
  className = "",
}) {
  const [tip, setTip] = useState(null);
  const max = Math.max(1, ...values.map((v) => Math.abs(v)));

  if (!values.length) {
    return <div className={`bar-chart bar-chart--empty ${className}`}>No data</div>;
  }

  return (
    <div className={`bar-chart ${className}`} style={{ position: "relative" }}>
      <div className="bar-chart-bars" style={{ height, marginTop: 8 }}>
        {values.map((v, i) => {
          const h = Math.round((Math.abs(v) / max) * (height - 8));
          const label = labels[i] || `Item ${i + 1}`;
          return (
            <div
              key={`${label}-${i}`}
              className="bar-chart-bar"
              style={{ height: Math.max(3, h), background: accent }}
              onMouseEnter={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const host = e.currentTarget.closest(".bar-chart");
                const hostRect = host?.getBoundingClientRect();
                setTip({
                  x: rect.left - (hostRect?.left || 0) + rect.width / 2,
                  y: rect.top - (hostRect?.top || 0),
                  placement: "above",
                  title: label,
                  lines: [`${v.toLocaleString()} sign-up${v === 1 ? "" : "s"}`],
                });
              }}
              onMouseLeave={() => setTip(null)}
            />
          );
        })}
      </div>
      {labels.length > 0 && (
        <div className="bar-chart-labels">
          {labels.map((l) => (
            <span key={l}>{l}</span>
          ))}
        </div>
      )}
      <ChartTooltip tip={tip} />
    </div>
  );
}
